<template>
	<div class="content-box">
	<div class="row">
		<div class="col-sm-5">
			<div class="user-profile compact">
				<div class="up-head-w" style="background-image:url(img/profile_bg1.jpg)">
					<div class="up-social">
						<a href="#"><i class="os-icon os-icon-twitter"></i></a><a href="#"><i class="os-icon os-icon-facebook"></i></a>
					</div>
					<div class="up-main-info">
						<h2 class="up-header">
							{{ user.firstName }} {{ user.middleName }} {{ user.lastName }} @{{ user.username }}
						</h2>
						<h6 class="up-sub-header">
							{{ user.group.name }}
						</h6>
					</div>
					<svg class="decor" width="842px" height="219px" viewBox="0 0 842 219" preserveAspectRatio="xMaxYMax meet" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g transform="translate(-381.000000, -362.000000)" fill="#FFFFFF"><path class="decor-path" d="M1223,362 L1223,581 L381,581 C868.912802,575.666667 1149.57947,502.666667 1223,362 Z"></path></g></svg>
				</div>
				<div class="up-controls">
					<div class="row">
						<div class="col-sm-12 text-right">
							<div class="value-pair pull-left">
								<div class="label">
									{{ t.last_activity }}:
								</div>
								<div class="value badge badge-pill" v-tooltip="dateTimeFormat(user.lastActivityAt)">
									{{ user.lastActivityAt | timeAgo }}
								</div>
							</div>
							<a class="btn btn-primary btn-sm" href=""><i class="os-icon os-icon-link-3"></i><span>Add to Friends</span></a>
						</div>
						<div class="col-sm-12">
							<div class="value-pair">
								<div class="label">
									{{ t.betting.title.status }}:
								</div>
								<div class="value badge badge-pill badge-success" v-if="user.isActiveNow">
									{{ t.user.online }}
								</div>
							</div>
							<div class="value-pair">
								<div class="label">
									{{ t.user.last_login }}:
								</div>
								<div class="value badge badge-pill" v-tooltip="dateTimeFormat(user.lastLogin)">
									{{ user.lastLogin | timeAgo }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="up-contents">
					<div class="m-b">
						<div class="row m-b">
							<div class="col-sm-6 b-r b-b">
								<div class="el-tablo centered padded-v">
									<div class="value">
										{{ user.stats.playedBets }}
									</div>
									<div class="label">
										{{ t.user.stats.played_bets }}
									</div>
								</div>
							</div>
							<div class="col-sm-6 b-b">
								<div class="el-tablo centered padded-v">
										<div class="value">
											{{ user.stats.waitingBets }}
										</div>
										<div class="label">
											{{ t.user.stats.waiting_bets }}
										</div>
								</div>
							</div>
						</div>
						<div class="padded">
							<div class="row">
								<div class="col-sm-6">
									<div class="listy b-b">
										<span class="label">
											{{ t.user.username }}
										</span>
										{{ user.username }}
									</div>
									<div class="listy b-b">
										<span class="label">
											{{ t.user.full_name }}
										</span>
										{{ user.firstName }} {{ user.middleName }} {{ user.lastName }}
									</div>
									<div class="listy b-b">
										<span class="label">
											{{ t.user.date_of_brith }}
										</span>
										{{ user.dateOfBirth | moment(session.date_format, session.timezone) }}
									</div>
									<div class="listy b-b">
										<span class="label">
											{{ t.user.age }}
										</span>
										{{ user.age }}
									</div>
									<div class="listy b-b">
										<span class="label">
											{{ t.user.region }}
										</span>
										{{ user.region.name }}
									</div>
									<div class="listy b-b">
										<span class="label">
											{{ t.user.status }}
										</span>
										<span v-if="user.enabled">
											{{ t.user.enabled }}
										</span>
										<span v-else>
										{{ t.user.disabled }}
										</span>
										<span v-if="user.deleted" class="badge badge-pill badge-danger">
											{{ t.user.deleted }}
										</span>
									</div>
								</div>
								<div class="col-sm-6">
									<div class="listy b-b">
										<span class="label">
											{{ t.user.mobile_phone }}
										</span>
										<span v-if="user.mobilePhone">
											+{{ user.mobilePhone.country_code }} {{ user.mobilePhone.national_number }}
										</span>
									</div>
									<div class="listy b-b">
										<span class="label">
											{{ t.finance.currency }}
										</span>
										{{ user.currency.iso_code }}
									</div>
									<div class="listy b-b">
										<span class="label">
											{{ t.user.balance }}
										</span>
										{{ user.balance }}
									</div>
									<div class="listy b-b">
										<span class="label">
											{{ t.user.credit }}
										</span>
										{{ user.credit }}
									</div>
									<div class="listy b-b">
										<span class="label">
											{{ t.user.bonus }}
										</span>
										{{ user.bonus }}
									</div>
									<div class="listy b-b">
										<span class="label">
											{{ t.user.email }}
										</span>
										{{ user.email }}
									</div>
								</div>
								<div class="col-sm-12">
									<div class="listy b-b">
										<span class="label">
											{{ t.user.home_address }}
										</span>
										{{ user.homeAddress }}
									</div>
									<div class="listy b-b">
										<span class="label">
											{{ t.affiliate.code }}
										</span>
										{{ user.ref }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
		<div class="col-sm-7">
			<activityWidget />
		</div>
	</div>
	</div>
</template>

<script>
	import activityWidget from '@/components/user/widget/activityWidget'

    export default {
        name: 'UserProfile',
	    components: { activityWidget },
        data () {
            return {
                session: this.$root.session,
                t: this.$root.t,
                isLoading: false,
	            uid: 0,
	            user: {}
            }
        },
	    mounted () {
            this.uid = this.$route.params.id;
            console.log(this.uid);
            this.fetchUser(this.uid);
	    },
	    methods: {
            fetchUser (uid) {
                if (!this.isLoading) {
                    this.isLoading = true;
                    this.$http.get(api+'api/v1/users?uid='+uid,
                        { params: this.$route.query })
                        .then(response => {
                            this.pagination = response.body.result.pagination;
                            this.user = response.body.result.users[0];
                            this.status = response.status;
	                        this.isLoading = false;
                        }, response => {
                            this.isLoading = false;
                            this.status = response.status;
                        })
                }
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/profile/index.vue